class SectionTypeSignupFormExtended {

	constructor() {
		this.container = '.section-type-signup_form_extended';

		this.setEvents();
	}

	setEvents() {
		jQuery(this.container).on('change','select', this.calculate.bind(this));
	}

	calculate(e) {
		var subtotal = 0;
		jQuery(this.container).find('select').each((it, el) => {
			subtotal += jQuery(el).val() * jQuery(el).data('price');
		});
		const opts = {
			currency: 'EUR',
			style: 'currency'
		};
		jQuery(this.container).find('.total').html(new Intl.NumberFormat('nl-NL', opts).format(subtotal));
		jQuery(this.container).find('[name=amount]').val(subtotal);
		return false;
	}

}

export default new SectionTypeSignupFormExtended;